import { useFeatureFlagEnabled } from "posthog-js/react";

import { POSTHOG_FEATURE_FLAGS } from "context/posthog/featureFlags";

export function useJAVAHideConnectFeatureFlag() {
  return useFeatureFlagEnabled(POSTHOG_FEATURE_FLAGS.javaHideConnect);
}
